import {type ReactNode, lazy, Suspense} from "react";
import {LoaderV5} from "../../../../loader/LoaderV5";
import type {Report} from "../../../../../../data/models/Report";

interface ILazyLoaderProps {
	readonly url: string;
	readonly report: Report;
	readonly fallback?: ReactNode;
	readonly onClose: () => void;
}

const componentMap: Record<string, () => Promise<{default: React.ComponentType<any>}>> = {
	KaiserCustomInputsForReports: () => import("./KaiserCustomInputsForReports"),
	TestCustomInputsForReports: () => import("./TestCustomInputsForReports"),
	SutterDeploymentReportCustomInput: () => import("./SutterDeploymentReportCustomInput"),
};

export const DynamicComponent = (props: ILazyLoaderProps) => {
	const fallback = props.fallback ?? <LoaderV5 />;
	const loader = componentMap[props.url];
	const LazyLoadedComponent = loader ? lazy(loader) : () => <div>Invalid component type</div>;

	return (
		<Suspense fallback={fallback}>
			<LazyLoadedComponent {...props} />
		</Suspense>
	);
};
